import css from 'styled-jsx/css';

const styles = css.global`.range-select {
}

.range-select .bar {
  position: relative;
  overflow: visible;
}

.range-select .bg {
  margin: 0;
  padding: 0;
  display: block;
  height: 4px;
  background: #727272;
  width: 100%;
  border-radius: 2px;
}

.range-select .indicator {
  width: 0%;

  position: absolute;
  top: 50%;
  left: 0;
  height: 4px;
  background: #cc0000;
  border-radius: 2px;
  z-index: 1;
  transform: translateY(-50%);
}

.range-select .thumb {
  left: 0%;

  position: absolute;
  z-index: 2;
  top: 50%;

  transform: translate(-50%, -50%);

  height: 32px;
  width: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
}

.range-select .thumb-display {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: #cc0000;
  display: block;
  pointer-events: none;
}

.range-select .values {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.range-select .values p {
  color: #444;
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  margin: 24px 0 0;
}
`;

export default styles;